import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import './users.css';
import RefershIcon from '../../../common/assets/images/reload.png';
import { Table, Spinner } from 'react-bootstrap';
import axiosInstance from '../../../axiosinterceptor';

const UserIndex = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));
    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const headers = {
        authorizationToken: sessionStorage.loginSession,
    };

    const [users, setUsers] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        axiosInstance
            .get('/GetUnacceptableUsersACS', { headers })
            .then((response) => {
                setUsers(response.data.data);
                toast.success(response.data.message);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log('Error: ' + error);
                setIsLoading(false);
            });
    }, [refresh]);

    const confirmactionUser = (email) => {
        axiosInstance
            .post('/AdminConfirmationUserAcs', { user_email: email }, { headers })
            .then((response) => {
                toast.success(response.data);
                setRefresh(!refresh);
            })
            .catch((err) => {
                console.log('Error: ' + err);
            });
    };

    const rejecttheUser = (email) => {
        axiosInstance
            .post('/RejecteUserRequestACS', { user_email: email }, { headers })
            .then((response) => {
                toast.success(response.data.message);
                setRefresh(!refresh);
            })
            .catch((err) => {
                console.log('Error: ' + err);
            });
    };

    return (
        <div className="userlist-section">
            <ToastContainer autoClose={20000} />
            <div className="userlist-header">
                <h4 className="userlist-header-text">User List</h4>
                <div className="userlist-filter-section">
                    <span className="userlist-refresh-btn" onClick={() => setRefresh(!refresh)}>
                        <span>
                            <img src={RefershIcon} alt="img" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Username</th>
                            <th className="userlist-th">Organization</th>
                            <th className="userlist-th">Country</th>
                            <th className="userlist-th">Role</th>
                            <th className="userlist-th">Email</th>
                            <th className="userlist-th">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="6">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) : users && users?.length > 0 ? (
                            users.map((user, index) => (
                                <tr key={index}>
                                    <td className="userlist-td">{user.username}</td>
                                    <td className="userlist-td">{user.organization_name}</td>
                                    <td className="userlist-td">{user.country_name}</td>
                                    <td className="userlist-td">{user.role}</td>
                                    <td className="userlist-td">{user.email}</td>
                                    <td className="userlist-td">
                                        <button className="user-confirm-btn p-2 mx-2" onClick={() => confirmactionUser(user.email)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-check2" viewBox="0 0 16 16">
                                                <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                                            </svg>
                                        </button>
                                        <button className="user-confirm-btn p-2" onClick={() => rejecttheUser(user.email)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                                                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                            </svg>
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default UserIndex;